// Motion from SpeakON-Agent-Animation-v18; configurable artwork is rendered by Liquid.
if (!customElements.get('speakon-agent-workflow')) {
  const voiceHeights = (() => {
const TAU = Math.PI * 2;
const clamp = value => Math.max(0, Math.min(1, value));
const smoothstep = value => { const p = clamp(value); return p * p * p * (p * (p * 6 - 15) + 10); };

// Real-time speech motion is independent of the step's reading/hold duration.
// Rounded bars follow speech pulses with continuous, offset harmonics.
function voiceHeights(elapsedMs, count = 13, reducedMotion = false) {
  const t = Math.max(0, elapsedMs) / 1000;
  const motionTime = t * .64;
  const phrases = [[.12,.1,.9],[.34,.11,1],[.58,.12,.85],[.83,.11,1],[1.08,.12,.9],[1.38,.14,1]];
  const pressure = phrases.reduce((sum,[center,width,strength]) => sum + strength * Math.exp(-.5 * ((t-center)/width)**2), 0);
  const envelope = (1-Math.exp(-pressure*1.7)) * smoothstep(t/.08) * (1-smoothstep((t-1.5)/.2));
  return Array.from({length:count}, (_,i) => {
    const center = (count-1)/2 + (reducedMotion ? 0 : .65*Math.sin(motionTime*8));
    const profile = .2 + .8*Math.exp(-.5*((i-center)/3.4)**2);
    if (reducedMotion) return 5 + 12*profile;
    const cadence = .55 + .25*Math.sin(TAU*6.8*motionTime-i*.71) + .13*Math.sin(TAU*9.7*motionTime+i*.47);
    const resting = 4.2 + .6*(.5+.5*Math.sin(motionTime*7-i*.2));
    return resting + 29*profile*envelope*cadence;
  });
}


return voiceHeights;
})();
  const {HARDWARE_OPENING_DURATION,createHardwareOpening} = (() => {

const HARDWARE_OPENING_DURATION = 1400;

const clamp = value => Math.max(0, Math.min(1, value));
const smooth = value => { const p = clamp(value); return p * p * p * (p * (p * 6 - 15) + 10); };
const mix = (from, to, progress) => from + (to - from) * progress;

function createHardwareOpening({ stage, card, waveform, voiceLabel, reducedMotion = false }) {
  const opening = stage.querySelector('.speakon-agent-flow__hardware-opening');
  opening.hidden = true;
  const flyingWave = stage.querySelector('.speakon-agent-flow__hardware-opening-wave');
  const device = opening.querySelector('.speakon-agent-flow__hardware-opening-device');
  const status = opening.querySelector('.speakon-agent-flow__hardware-opening-status');
  const stateLabel = opening.querySelector('.speakon-agent-flow__hardware-opening-state');
  const ring = opening.querySelector('.speakon-agent-flow__hardware-opening-ring');
  const flyingBars = [...flyingWave.querySelectorAll('i')];
  const liveBars = [...waveform.querySelectorAll('i')];
  const originalCard = { opacity: card.style.opacity, inert: card.inert, ariaHidden: card.getAttribute('aria-hidden') };
  const originalWaveVisibility = waveform.style.visibility;
  const originalLabelOpacity = voiceLabel.style.opacity;
  let geometry;
  let isActive = false;


  function measure() {
    const stageRect = stage.getBoundingClientRect();
    const target = waveform.getBoundingClientRect();
    if (!stageRect.width || !stageRect.height || !target.width || !target.height || waveform.closest('[hidden]')) return false;
    const wasHidden = opening.hidden;
    const oldTransform = opening.style.transform;
    opening.hidden = false;
    opening.style.transform = 'none';
    const source = status.getBoundingClientRect();
    opening.hidden = wasHidden;
    opening.style.transform = oldTransform;
    geometry = {
      from: { x: source.left - stageRect.left, y: source.top - stageRect.top, width: source.width, height: source.height },
      to: { x: target.left - stageRect.left, y: target.top - stageRect.top, width: target.width, height: target.height }
    };
    return true;
  }

  function clear() {
    opening.hidden = true;
    opening.inert = true;
    opening.setAttribute('aria-hidden', 'true');
    flyingWave.hidden = true;
    card.style.opacity = originalCard.opacity;
    card.inert = originalCard.inert;
    if (originalCard.ariaHidden === null) card.removeAttribute('aria-hidden');
    else card.setAttribute('aria-hidden', originalCard.ariaHidden);
    waveform.style.visibility = originalWaveVisibility;
    voiceLabel.style.opacity = originalLabelOpacity;
    // The hardware handoff already brought the card in. Do not restart the
    // scene's CSS entrance when its temporary animation override is removed.
    waveform.closest('.speakon-agent-flow__request-scene')?.classList.remove('entering');
    stage.classList.remove('speakon-agent-flow__hardware-opening-active');
    isActive = false;
  }

  function render(elapsed, active) {
    if (!active || reducedMotion || elapsed >= HARDWARE_OPENING_DURATION) {
      if (isActive) clear();
      return;
    }

    if (!isActive) {
      opening.hidden = false;
      opening.inert = false;
      opening.setAttribute('aria-hidden', 'false');
      stage.classList.add('speakon-agent-flow__hardware-opening-active');
      isActive = true;
      card.style.opacity = '0';
      card.inert = true;
      card.setAttribute('aria-hidden', 'true');
      waveform.style.visibility = 'hidden';
      voiceLabel.style.opacity = '0';
      measure();
    }
    if (!geometry && !measure()) return;

    const time = Math.max(0, elapsed);
    const productOut = smooth((time - 780) / 470);
    const cardIn = smooth((time - 850) / 550);
    const handoff = smooth((time - 560) / 840);
    const statusOut = smooth((time - 500) / 140);
    const ringProgress = clamp((time - 220) / 640);
    const press = Math.sin(clamp((time - 230) / 420) * Math.PI);

    opening.style.opacity = String(1 - productOut);
    opening.style.transform = `translateY(${-8 * productOut}px) scale(${1 - .025 * productOut})`;
    opening.inert = productOut > .8;
    opening.setAttribute('aria-hidden', String(productOut > .8));
    device.style.transform = `scale(${1 - .018 * press})`;
    ring.style.opacity = String(Math.sin(ringProgress * Math.PI) * .48);
    ring.style.transform = `translate(-50%,-50%) scale(${.7 + ringProgress * 1.1})`;
    stateLabel.textContent = time < 360 ? stateLabel.dataset.press : stateLabel.dataset.listening;
    status.style.opacity = String(1 - statusOut);

    card.style.opacity = String(cardIn);
    card.inert = true;
    card.setAttribute('aria-hidden', 'true');
    waveform.style.visibility = 'hidden';
    voiceLabel.style.opacity = String(smooth((time - 1140) / 260));

    const { from, to } = geometry;
    flyingWave.hidden = time < 500;
    flyingWave.style.opacity = String(smooth((time - 500) / 140));
    flyingWave.style.width = `${mix(from.width, to.width, handoff)}px`;
    flyingWave.style.height = `${mix(from.height, to.height, handoff)}px`;
    flyingWave.style.transform = `translate3d(${mix(from.x, to.x, handoff)}px,${mix(from.y, to.y, handoff) - 10 * Math.sin(handoff * Math.PI)}px,0)`;
    const settle = smooth((time - 1180) / 220);
    const heights = voiceHeights(Math.max(0, time - 360), 13, false);
    const restingHeights = voiceHeights(0, 13, false);
    heights.forEach((height, index) => {
      const value = mix(height, restingHeights[index], settle);
      flyingBars[index].style.height = `${value.toFixed(3)}px`;
      if (liveBars[index]) liveBars[index].style.height = `${value.toFixed(3)}px`;
    });
  }

  const resizeObserver = new ResizeObserver(() => {
    geometry = undefined;
    if (isActive) measure();
  });
  resizeObserver.observe(stage);

  return { render, measure, destroy() { clear(); resizeObserver.disconnect(); } };
}

return {HARDWARE_OPENING_DURATION,createHardwareOpening};
})();
  const {UNDERSTAND_DURATION,createUnderstandScene} = (() => {
const UNDERSTAND_DURATION = 3300;

const clamp = value => Math.max(0, Math.min(1, value));
const ease = value => 1 - Math.pow(1 - clamp(value), 3);
const smooth = value => { const p=clamp(value); return p*p*(3-2*p); };
const flightStart = task => 1180 + task*110;
/** One scene driven entirely by the workflow clock, including every spinner. */
function createUnderstandScene({host, request, phrases, reducedMotion=false}) {
  const element = host.querySelector('.speakon-agent-flow__understand-scene');
  const transcript = element.querySelector('.speakon-agent-flow__u-transcript');
  transcript.replaceChildren();
  const keywords = [];
  const prose = [];
  function appendProse(text) {
    const span=document.createElement('span');
    span.textContent=text;
    transcript.append(span);
    prose.push(span);
  }
  let cursor = 0;
  for (const [key, phrase] of phrases.entries()) {
    const position = request.toLowerCase().indexOf(phrase.text.toLowerCase(), cursor);
    if (position < 0) continue;
    appendProse(request.slice(cursor, position));
    const word = document.createElement('span');
    word.className = 'speakon-agent-flow__u-keyword';
    word.textContent = request.slice(position, position + phrase.text.length);
    transcript.append(word);
    keywords.push({word, key, ...phrase});
    cursor = position + phrase.text.length;
  }
  appendProse(request.slice(cursor));

  const headerCarry=element.querySelector('.speakon-agent-flow__u-header-carry');
  const voiceCarry=element.querySelector('.speakon-agent-flow__u-voice-carry');
  const taskList=element.querySelector('.speakon-agent-flow__u-task-list');
  const note=element.querySelector('.speakon-agent-flow__u-preparing-note');
  const flights=element.querySelector('.speakon-agent-flow__u-flight-layer');
  const rows = [...taskList.querySelectorAll('.speakon-agent-flow__u-task-row')];
  const rings = [...taskList.querySelectorAll('.speakon-agent-flow__u-pending-ring')];
  const contents=rows.map(row=>[...row.children]);
  let paths = [];
  let elapsed = 0;
  let entered = false;
  let measuredWidth = 0;
  let carryOffsetY = 0;

  function capture() {
    const card=host.closest('.speakon-agent-flow__task-card'), box=card.getBoundingClientRect();
    const copy=host.querySelector('.speakon-agent-flow__request-copy');
    const header=card.querySelector('.speakon-agent-flow__task-header');
    const voice=host.querySelector('.speakon-agent-flow__request-scene .speakon-agent-flow__voice-area');
    return {copyY:copy.getBoundingClientRect().top-box.top,
      headerY:header.getBoundingClientRect().top-box.top,
      voiceY:voice.getBoundingClientRect().top-box.top,
      header:header.cloneNode(true),voice:voice.cloneNode(true)};
  }

  function measure() {
    if (element.hidden || !element.getClientRects().length) return;
    // Measure only on entry or resize, never in the animation clock.
    transcript.style.transform = `translateY(${carryOffsetY}px)`;
    rows.forEach(row => row.style.transform = 'none');
    const sceneBox = element.getBoundingClientRect();
    if (!sceneBox.width) return;
    measuredWidth = sceneBox.width;
    const requestCopy = host.querySelector('.speakon-agent-flow__request-copy');
    if (requestCopy) {
      const textStyle = getComputedStyle(requestCopy);
      for (const property of ['font-size','line-height','letter-spacing','font-weight']) {
        transcript.style.setProperty(property,textStyle.getPropertyValue(property));
        flights.style.setProperty(property,textStyle.getPropertyValue(property));
      }
    }
    paths = [];
    flights.replaceChildren();
    keywords.forEach(({word,task,key:keywordIndex}) => {
      // Group the original characters by their rendered line. This also
      // handles phrases that wrap on a 320 px screen without duplicating or
      // clipping letters in the flying fragments.
      const textNode = word.firstChild;
      const range = document.createRange();
      const fragments = [];
      for (let index=0; index<word.textContent.length; index++) {
        range.setStart(textNode,index);
        range.setEnd(textNode,index+1);
        const rect = range.getBoundingClientRect();
        let line = fragments[fragments.length-1];
        if (!line || Math.abs(line.top-rect.top)>2) {
          line = {left:rect.left,top:rect.top,right:rect.right,height:rect.height,text:''};
          fragments.push(line);
        }
        line.text += word.textContent[index];
        line.right = rect.right;
      }
      const targetBox=taskList.querySelector(`[data-key="${keywordIndex}"]`).getClientRects()[0];
      fragments.forEach((rect, fragmentIndex) => {
        const wrapper = document.createElement('span');
        wrapper.className = 'speakon-agent-flow__u-flight-fragment';
        wrapper.style.width = `${rect.right-rect.left+1}px`;
        wrapper.style.height = `${rect.height}px`;
        wrapper.style.lineHeight = `${rect.height}px`;
        wrapper.textContent = rect.text;
        flights.append(wrapper);
        const startX = rect.left-sceneBox.left;
        const startY = rect.top-sceneBox.top;
        const targetX = targetBox.left-sceneBox.left;
        const targetY = targetBox.top-sceneBox.top + Math.min(fragmentIndex,1)*3;
        paths.push({element:wrapper,startX,startY,targetX,targetY,keywordIndex,task});
      });
    });
  }

  function enter({carry=null}={}) {
    entered = true;
    elapsed = 0;
    const bodyY=host.getBoundingClientRect().top-host.closest('.speakon-agent-flow__task-card').getBoundingClientRect().top;
    carryOffsetY = carry ? carry.copyY-bodyY : 0;
    headerCarry.replaceChildren();
    voiceCarry.replaceChildren();
    if (carry && !reducedMotion) {
      for(const [wrapper,clone,y] of [[headerCarry,carry.header,carry.headerY],[voiceCarry,carry.voice,carry.voiceY]]) {
        for (const node of [clone,...clone.querySelectorAll('*')]) node.removeAttribute('id');
        wrapper.append(clone);
        wrapper.style.top=`${y-bodyY}px`;
      }
    }
    measure();
    render(0);
  }

  function render(time) {
    elapsed = Math.max(0,time);
    const staticTasks = reducedMotion;
    const paragraphExit=staticTasks ? 1 : smooth((elapsed-1020)/450);
    prose.forEach(span=>span.style.opacity=String(1-paragraphExit));
    transcript.style.transform = `translateY(${carryOffsetY}px)`;
    transcript.style.visibility = staticTasks || elapsed>1660 ? 'hidden' : 'visible';
    headerCarry.style.opacity=String(staticTasks ? 0 : 1-smooth((elapsed-250)/650));
    voiceCarry.style.opacity = String(staticTasks ? 0 : 1-smooth((elapsed-250)/500));

    keywords.forEach(({word,task},index) => {
      const emphasis = smooth((elapsed-170-index*75)/240);
      word.style.backgroundColor = `rgba(18,18,18,${.105*emphasis})`;
      word.style.opacity=String(staticTasks ? 0 : 1-smooth((elapsed-flightStart(task))/100));
    });

    for (const path of paths) {
      const start = flightStart(path.task);
      const travel = clamp((elapsed-start)/760);
      const p = smooth(travel);
      const opacity = staticTasks ? 0 : smooth((elapsed-start)/100)*(1-smooth((travel-.74)/.26));
      // Keep each phrase visible until it reaches its own title/detail slot.
      const x = path.startX+(path.targetX-path.startX)*p;
      const y = path.startY+(path.targetY-path.startY)*p-Math.sin(Math.PI*p)*12;
      path.element.style.opacity = String(opacity);
      path.element.style.transform = `translate(${x}px,${y}px) scale(${1-p*.08})`;
    }

    rows.forEach((row,index) => {
      const start=flightStart(index);
      const p = staticTasks ? 1 : smooth((elapsed-start-210)/620);
      row.style.opacity = String(p);
      row.style.transform = `translateY(${(1-p)*5}px)`;
      const ink=staticTasks ? 1 : smooth((elapsed-start-590)/330);
      contents[index].forEach(child=>child.style.opacity=String(ink));
      row.inert=ink<.9;
      rings[index].style.transform = `rotate(${staticTasks ? 0 : elapsed*.32+index*72}deg)`;
    });
    const footer = staticTasks ? 1 : ease((elapsed-2560)/320);
    note.style.opacity = String(footer);
    note.style.transform = `translateY(${(1-footer)*4}px)`;
  }

  function reset() {
    entered = false;
    elapsed = 0;
    voiceCarry.replaceChildren();
    headerCarry.replaceChildren();
    paths = [];
    flights.replaceChildren();
    render(0);
  }

  const resizeObserver = new ResizeObserver(entries => {
    if (!entered || element.hidden) return;
    const box = entries[0].contentRect;
    if (Math.abs(box.width-measuredWidth)>.5) {
      measure();
      render(elapsed);
    }
  });
  resizeObserver.observe(element);
  reset();
  return {element,capture,enter,render,reset,destroy() { resizeObserver.disconnect(); reset(); }};
}

return {UNDERSTAND_DURATION,createUnderstandScene};
})();
  const {CONTEXT_DURATION,createContextScene} = (() => {
const CONTEXT_DURATION = 3000;

const clamp = value => Math.min(1, Math.max(0, value));
const smooth = value => {
  const p = clamp(value);
  return p * p * (3 - 2 * p);
};

function createContextScene({ host, reducedMotion = false }) {
  const element = host.querySelector('.speakon-agent-flow__context-search');
  const calendar = element.querySelector('.speakon-agent-flow__cx-calendar');
  const scan = element.querySelector('.speakon-agent-flow__cx-scan');
  const available = element.querySelector('.speakon-agent-flow__cx-available');
  const availableLabel = element.querySelector('.speakon-agent-flow__cx-available-label');
  const availableState = element.querySelector('.speakon-agent-flow__cx-available-state');
  const dayStatus = element.querySelector('.speakon-agent-flow__cx-day-status');
  const searchStatus = element.querySelector('.speakon-agent-flow__cx-search-status');
  const contextCards = [...element.querySelectorAll('.speakon-agent-flow__cx-context-card')];
  const footer = element.querySelector('.speakon-agent-flow__cx-footer');
  const footerLabel = element.querySelector('.speakon-agent-flow__cx-footer-label');

  function render(elapsed = 0) {
    const time = reducedMotion ? CONTEXT_DURATION : Math.max(0, elapsed);
    const calendarIn = smooth(time / 220);
    const scanProgress = smooth((time - 220) / 1040);
    const found = smooth((time - 1180) / 400);
    const scanOut = smooth((time - 1220) / 200);
    const searchDone = time >= 1450;

    calendar.style.opacity = String(calendarIn);
    calendar.style.transform = `translateY(${(1 - calendarIn) * 6}px)`;
    scan.style.opacity = String(smooth((time - 160) / 180) * (1 - scanOut) * .8);
    scan.style.transform = `translateY(${scanProgress * 82}px)`;
    available.style.opacity = String(found);
    available.style.transform = `scaleY(${.78 + found * .22})`;
    availableLabel.style.opacity = String(smooth((time - 1250) / 240));
    availableState.style.opacity = String(smooth((time - 1380) / 220));
    dayStatus.textContent = searchDone ? dayStatus.dataset.resolved : dayStatus.dataset.pending;
    dayStatus.classList.toggle('speakon-agent-flow__cx-resolved', searchDone);
    searchStatus.classList.toggle('speakon-agent-flow__cx-resolved', searchDone);
    searchStatus.firstElementChild.style.transform = `rotate(${Math.sin(time / 270) * 10}deg)`;

    contextCards.forEach((card, index) => {
      const start = 1350 + index * 190;
      const progress = smooth((time - start) / 300);
      const settle = smooth((time - start - 120) / 240);
      card.style.opacity = String(progress);
      card.style.transform = `translateY(${(1 - progress) * 8}px)`;
      const check = card.querySelector('.speakon-agent-flow__cx-found');
      check.style.opacity = String(settle);
      check.style.transform = `scale(${.75 + settle * .25})`;
    });

    const connected = time >= 2310;
    footer.style.opacity = String(smooth((time - 850) / 240));
    footer.classList.toggle('speakon-agent-flow__cx-resolved', connected);
    footerLabel.textContent = connected ? footerLabel.dataset.resolved : footerLabel.dataset.pending;
  }

  function enter() { render(0); }
  function reset() { render(0); }
  render(0);
  return { element, enter, render, reset };
}

return {CONTEXT_DURATION,createContextScene};
})();
  const {PREPARE_DURATION,createPrepareScene} = (() => {
const PREPARE_DURATION = 2500;
const clamp = value => Math.max(0, Math.min(1, value));
const ease = value => 1 - (1 - clamp(value)) ** 3;

function createPrepareScene({host, reducedMotion=false}) {
  const element=host.querySelector('.speakon-agent-flow__prepare-overview');
  const tiles=[...element.querySelectorAll('.speakon-agent-flow__prep-tile')];
  const footer=element.querySelector('.speakon-agent-flow__prep-footer');
  function render(elapsed) {
    tiles.forEach((tile,index)=>{
      const p=reducedMotion?1:ease((elapsed-80-index*100)/420);
      tile.style.opacity=String(p);
      tile.style.transform=`translateY(${(1-p)*12}px) scale(${.98+.02*p})`;
      const detail=tile.querySelector('.speakon-agent-flow__prep-detail');
      detail.style.opacity=String(reducedMotion?1:ease((elapsed-600-index*100)/300));
    });
    footer.style.opacity=String(reducedMotion?1:ease((elapsed-1000)/300));
  }
  return {element,enter:()=>render(0),render,reset:()=>{}};
}

return {PREPARE_DURATION,createPrepareScene};
})();
  const {COMPLETE_RESULTS_DURATION,createCompleteResults} = (() => {
const COMPLETE_RESULTS_DURATION = 8250;
const clamp = n => Math.min(1, Math.max(0, n));
const ease = n => 1 - (1 - clamp(n)) ** 3;
const RESULTS_AT = 1900, SCROLL_START = 3100, SCROLL_END = 7500;

// Accelerate gently, move faster through the middle, and settle on the last result.
function scrollProgress(t) {
  const p = clamp(t);
  return p * p * (3 - 2 * p);
}

/** A continuous result strip, driven by the owning six-step clock. */
function createCompleteResults({ host, taskScene, reducedMotion = false }) {
  const element = host.querySelector('.speakon-agent-flow__complete-results');
  element.dataset.reduced = String(reducedMotion);
  const track = element.querySelector('.speakon-agent-flow__cr-result-track');
  const cards = [...element.querySelectorAll('.speakon-agent-flow__cr-result-card')];
  const originalOpacity = taskScene.style.opacity, originalTransform = taskScene.style.transform;
  let geometry, wasActive = false;
  function measure() {
    const height = host.clientHeight;
    geometry = { width: host.clientWidth, height, maxScroll: Math.max(0, track.scrollHeight - height),
      cards: cards.map(card => ({ top: card.offsetTop, bottom: card.offsetTop + card.offsetHeight })) };
  }
  function reset() {
    element.hidden = true;
    element.inert = true;
    element.setAttribute('aria-hidden', 'true');
    element.scrollTop = 0;
    taskScene.style.opacity = originalOpacity;
    taskScene.style.transform = originalTransform;
    taskScene.removeAttribute('aria-hidden');
    wasActive = false;
    geometry = null;
  }
  function render(elapsed, active) {
    if (!active || elapsed < RESULTS_AT) { if (wasActive) reset(); return; }
    element.hidden = false;
    element.inert = false;
    element.setAttribute('aria-hidden', 'false');
    if (!geometry || geometry.width !== host.clientWidth || geometry.height !== host.clientHeight) measure();
    const entrance = reducedMotion ? 1 : ease((elapsed - RESULTS_AT) / 460);
    const progress = reducedMotion ? 0 : scrollProgress((elapsed - SCROLL_START) / (SCROLL_END - SCROLL_START));
    const distance = geometry.maxScroll * progress;
    taskScene.classList.remove('entering');
    taskScene.style.opacity = String(1 - entrance);
    taskScene.style.transform = `translateY(${-8 * entrance}px)`;
    taskScene.setAttribute('aria-hidden', 'true');
    track.style.opacity = String(entrance);
    track.style.transform = `translate3d(0,${16 * (1 - entrance) - distance}px,0)`;
    element.dataset.scrollPhase = progress === 0 ? 'start' : progress === 1 ? 'end' : 'scrolling';
    let destination = 0;
    cards.forEach((card, i) => {
      const box = geometry.cards[i];
      const visible = reducedMotion || box.bottom > distance + 4 && box.top < distance + geometry.height - 4;
      card.inert = !visible;
      card.setAttribute('aria-hidden', String(!visible));
      if (box.top <= distance + geometry.height * .35) destination = i;
    });
    element.dataset.destination = cards[destination].dataset.resultKind;
    wasActive = true;
  }
  return { element, render, reset };
}

return {COMPLETE_RESULTS_DURATION,createCompleteResults};
})();
  const {CHECK_FINISHED_AT,paintCompletion,createCelebration} = (() => {
const COMPLETE_DURATION = 3300;
const CHECK_START = 180;
const CHECK_STAGGER = 310;
const CHECK_DURATION = 400;
const CHECK_FINISHED_AT = CHECK_START + 3 * CHECK_STAGGER + CHECK_DURATION;
const CELEBRATION_START = 1670;
const CELEBRATION_DURATION = 1300;
const clamp = value => Math.max(0, Math.min(1, value));
const smooth = value => { const p = clamp(value); return p * p * (3 - 2 * p); };

const checkMarkup = '<svg class="speakon-agent-flow__status-check" viewBox="0 0 22 22" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="9.167" fill="#22C55E"/><path class="speakon-agent-flow__check-mark" d="m6.9 10.9 3 3 5.2-5.2" pathLength="1" stroke="white" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function paintCompletion(status, elapsed, index, reducedMotion) {
  const progress = clamp((elapsed - CHECK_START - index * CHECK_STAGGER) / CHECK_DURATION);
  const p = reducedMotion ? Number(progress === 1) : progress;
  const circle = status.querySelector('.speakon-agent-flow__status-check');
  const pending = status.querySelector('.speakon-agent-flow__status-pending');
  // The onboarding reference reveals the complete badge as one shape:
  // grow quickly, briefly overshoot, then settle without a separate stroke draw.
  const growth = clamp(p / .6);
  const scale = p < .6 ? 1.28 * (1 - (1 - growth) ** 2) : 1 + .28 * (1 - smooth((p - .6) / .4));
  circle.style.opacity = p > 0 ? '1' : '0';
  circle.style.transform = `scale(${scale})`;
  status.querySelector('.speakon-agent-flow__check-mark').style.strokeDashoffset = '0';
  pending.style.opacity = String(1 - smooth(p / .18));
  return progress === 1;
}

// A single timeline drives the particles as well as the UI, so pause, tab
// visibility, and step navigation cannot leave an independent effect running.
function createCelebration(reducedMotion) {
  const canvas = document.createElement('canvas');
  canvas.className = 'speakon-agent-flow__celebration-layer';
  canvas.setAttribute('aria-hidden', 'true');
  canvas.hidden = true;
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  const palette = ['#22C55E', '#86EFAC', '#E5EF16', '#121212', '#B9C2BA'];
  const noise = n => { const value = Math.sin(n * 127.1 + 31.7) * 43758.5453; return value - Math.floor(value); };
  const particles = Array.from({length:72}, (_,i) => ({
    side: i % 2 ? 1 : -1, spread: .15 + noise(i + 3) * .85,
    rise: 290 + noise(i + 91) * 210, width: 3 + noise(i + 47) * 3,
    height: 5 + noise(i + 72) * 4, spin: (noise(i + 17) - .5) * 13,
    rotation: noise(i + 29) * Math.PI, color: palette[i % palette.length],
    delay: noise(i + 104) * .07,
  }));
  let origin = null;
  function clear() {
    if (!canvas.hidden) ctx?.clearRect(0,0,canvas.width,canvas.height);
    canvas.hidden = true;
    origin = null;
  }
  function render(elapsed, card, playing) {
    const age = elapsed - CELEBRATION_START;
    if (reducedMotion || !ctx || age < 0 || age >= CELEBRATION_DURATION || (!playing && canvas.hidden)) {
      clear(); return;
    }
    const width = innerWidth, height = innerHeight, dpr = Math.min(devicePixelRatio || 1, 2);
    if (canvas.width !== Math.round(width*dpr) || canvas.height !== Math.round(height*dpr)) {
      canvas.width = Math.round(width*dpr); canvas.height = Math.round(height*dpr);
    }
    if (!origin) {
      const rect = card.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > height) return;
      origin = {x:Math.max(width*.2,Math.min(width*.8,rect.left+rect.width/2)),y:Math.max(height*.3,Math.min(height*.75,rect.top+rect.height*.45))};
    }
    canvas.hidden = false;
    ctx.setTransform(dpr,0,0,dpr,0,0);
    ctx.clearRect(0,0,width,height);
    const spread = Math.min(width*.47,340);
    const compact = width < 700 ? .78 : 1;
    particles.slice(0,width < 700 ? 50 : 72).forEach(p => {
      const t = age/1000-p.delay;
      if (t < 0) return;
      const alpha = smooth(t/.055) * (1-smooth((t-.75)/.48));
      const x = origin.x+p.side*(22+spread*p.spread*(1-Math.exp(-t*2.1)));
      const y = origin.y-p.rise*compact*t+370*t*t;
      ctx.save();ctx.translate(x,y);ctx.rotate(p.rotation+t*p.spin);
      ctx.globalAlpha = alpha;ctx.fillStyle = p.color;
      ctx.scale(.4+.6*Math.abs(Math.cos(t*9+p.rotation)),1);
      ctx.fillRect(-p.width/2,-p.height/2,p.width,p.height);ctx.restore();
    });
  }
  return {render,clear,destroy() { clear(); canvas.remove(); }};
}

return {CHECK_FINISHED_AT,paintCompletion,createCelebration};
})();
  const durations = [HARDWARE_OPENING_DURATION + 2200, UNDERSTAND_DURATION + 550, CONTEXT_DURATION + 550, PREPARE_DURATION + 650, 3800, COMPLETE_RESULTS_DURATION + 650];
    const prefix = '.speakon-agent-workflow__';
  const flow = '.speakon-agent-flow__';
  const clamp = value => Math.min(1, Math.max(0, value));

  customElements.define('speakon-agent-workflow', class extends HTMLElement {
    connectedCallback() {
      this.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.tabs = [...this.querySelectorAll('[data-workflow-step]')];
      this.stage = this.querySelector('[data-workflow-stage]');
      if (!this.stage || this.tabs.length !== 6) return;
      this.card = this.querySelector('[data-flow-card]');
      this.body = this.querySelector('[data-flow-body]');
      this.scenes = [...this.body.querySelectorAll(`${flow}scene`)];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.labels = JSON.parse(this.querySelector('[data-flow-labels]').dataset.labels);
      this.activeStep = null;
      this.navigationAnimations = [];
      this.exitDescriptions = new Map();
      this.inView = false;
      this.index = -1;
      this.elapsed = 0;
      this.previousFrame = null;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.setupPlayers();
      this.select(0, false, false);
      this.setAttribute('data-enhanced', '');
      this.tabs.forEach(tab => {
        tab.addEventListener('click', event => this.select(Number(tab.dataset.workflowStep), true, event.detail > 0), options);
        tab.addEventListener('keydown', event => {
          const current = this.tabs.indexOf(tab);
          let next;
          if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (current + 1) % 6;
          if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (current + 5) % 6;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = 5;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next, true, false);
          this.tabs[next].focus({ preventScroll: true });
        }, options);
      });
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.motion.addEventListener('change', () => {
        const index = this.index;
        this.destroyPlayers();
        this.setupPlayers();
        this.select(index, false, false);
      }, options);
      if (window.IntersectionObserver) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
          this.updatePlayback();
        }, { threshold: .15 });
        this.observer.observe(this.stage);
      } else this.inView = true;
      this.updatePlayback();
    }

    setupPlayers() {
      const reducedMotion = this.motion.matches;
      const requestCopy = this.querySelector(`${flow}request-copy`);
      const request = requestCopy.textContent.trim();
      const emphasized = [...requestCopy.querySelectorAll('strong')];
      const phrases = this.labels.keywords.map((text, i) => ({
        text: text || emphasized[i]?.textContent || '', task: [0, 0, 0, 1, 2, 3][i]
      }));
      this.understand = createUnderstandScene({ host: this.body, request, phrases, reducedMotion });
      this.context = createContextScene({ host: this.body, reducedMotion });
      this.prepare = createPrepareScene({ host: this.body, reducedMotion });
      this.results = createCompleteResults({ host: this.body, taskScene: this.scenes[5], reducedMotion });
      this.celebration = createCelebration(reducedMotion);
      this.opening = createHardwareOpening({ stage: this.stage, card: this.card,
        waveform: this.querySelector(`${flow}waveform`), voiceLabel: this.querySelector('[data-voice-label]'), reducedMotion });
      this.completeRows = [...this.scenes[5].querySelectorAll(`${flow}task-row`)];
    }

    select(index, manual = false, animateNavigation = true) {
      const carry = index === 1 && this.index === 0 ? this.understand.capture() : null;
      this.index = index;
      this.elapsed = 0;
      this.previousFrame = null;
      if (manual) this.autoplayEnabled = true;
      this.results.reset();
      this.understand.reset();
      this.context.reset();
      this.celebration.clear();
      this.scenes.forEach((scene, i) => { scene.hidden = i !== index; });
      this.card.dataset.phase = String(index);
      this.opening.render(0, index === 0 && !this.motion.matches);
      if (index === 1) this.understand.enter({ carry });
      if (index === 2) this.context.enter();
      if (index === 3) this.prepare.enter();
      this.renderNavigation(index, animateNavigation);
      this.renderFrame();
      if ((manual || this.inView) && matchMedia('(max-width: 767px)').matches) {
        const active = this.tabs[index], nav = active.parentElement;
        nav.scrollTo({ left: active.offsetLeft - nav.offsetLeft - 12, behavior: this.motion.matches || !animateNavigation ? 'instant' : 'smooth' });
      }
      this.updatePlayback();
    }

    renderFrame() {
      // The source's six clocks are preserved, including the Complete handoff and result strip.
      const t = this.motion.matches || !this.autoplayEnabled ? [0, 3000, 3000, 2500, 2700, 1750][this.index] : this.elapsed;
      this.tabs.forEach((tab, i) => {
        const axis = matchMedia('(max-width: 767px)').matches ? 'X' : 'Y';
        const progress = i === this.index ? this.motion.matches || !this.autoplayEnabled ? 1 : clamp(t / durations[i]) : 0;
        tab.querySelector(`${prefix}step-progress`).style.transform = `scale${axis}(${progress})`;
      });
      this.dataset.phase = this.index === 0 ? t < 1400 ? 'press' : 'voice' : this.index === 5 && t >= 1900 ? 'results' : ['request', 'understand', 'context', 'prepare', 'review', 'complete'][this.index];
      this.opening.render(t, this.index === 0 && t < HARDWARE_OPENING_DURATION);
      if (this.index === 0) {
        const requestElapsed = this.motion.matches ? 1900 : Math.max(0, t - HARDWARE_OPENING_DURATION);
        const reveal = this.motion.matches ? 1 : clamp((requestElapsed - 900) / 300);
        const ink = reveal * reveal * (3 - 2 * reveal);
        const copy = this.querySelector(`${flow}request-copy`), label = this.querySelector('[data-voice-label]');
        copy.style.opacity = String(ink);
        copy.style.transform = `translateY(${(1 - ink) * 5}px)`;
        copy.setAttribute('aria-hidden', String(ink === 0));
        label.textContent = requestElapsed < 900 ? label.dataset.listening : label.dataset.captured;
        const bars = [...this.querySelectorAll(`${flow}waveform i`)];
        const heights = voiceHeights(requestElapsed, bars.length, this.motion.matches);
        const settle = clamp((requestElapsed - 720) / 180);
        const activity = 1 - settle * settle * (3 - 2 * settle);
        bars.forEach((bar, i) => { bar.style.height = `${4.8 + (heights[i] - 4.8) * activity}px`; });
      }
      if (this.index === 1) this.understand.render(t);
      if (this.index === 2) this.context.render(t);
      if (this.index === 3) this.prepare.render(t);
      if (this.index === 4) {
        const time = t * 1.5, arrival = clamp((time - 3000) / 400);
        const cursor = this.querySelector(`${flow}demo-cursor`), confirm = this.querySelector(`${flow}confirm-button`);
        cursor.style.opacity = this.motion.matches ? '0' : String(time > 3900 ? clamp((4200 - time) / 300) : arrival);
        cursor.style.transform = `translate(${(1 - arrival) * 35}px,${(1 - arrival) * 28}px)`;
        confirm.classList.toggle('speakon-agent-flow__pressed', time >= 3550 && time < 3750);
        confirm.textContent = time >= 3750 ? confirm.dataset.confirmed : confirm.dataset.confirm;
        const caption = this.querySelector(`${flow}approval-caption`);
        caption.textContent = time >= 3750 ? caption.dataset.approved : caption.dataset.pending;
      }
      if (this.index === 5) {
        let done = 0;
        this.completeRows.forEach((row, i) => {
          if (paintCompletion(row.querySelector(`${flow}task-status`), t, i, this.motion.matches)) done++;
          row.querySelector(`${flow}status-pending`).style.transform = `rotate(${i === done ? t / 5 : 0}deg)`;
        });
        this.querySelector('[data-complete-event] > span').textContent = done < 4 ? this.labels.execution[done] : this.labels.completed;
        this.querySelector('[data-complete-pending]').hidden = done === 4;
        this.querySelector('[data-complete-summary]').hidden = done !== 4;
        const summary = this.querySelector(`${flow}task-summary`);
        summary.classList.toggle('speakon-agent-flow__complete-summary', done === 4);
        summary.style.opacity = String(done === 4 ? clamp((t - CHECK_FINISHED_AT) / 200) : 1);
        summary.style.transform = `translateY(${done === 4 ? (1 - clamp((t - CHECK_FINISHED_AT) / 200)) * 4 : 0}px)`;
        this.celebration.render(t, this.card, this.hasAttribute('data-running'));
        this.results.render(t, true);
      }
    }

    renderNavigation(step, animate) {
      const moving = animate && !this.motion.matches && this.inView && !matchMedia('(max-width: 767px)').matches;
      if (!moving) this.clearNavigationMotion();
      if (this.activeStep === step) return;
      // FLIP the six rows and their rules: text keeps its size, with no per-frame layout work.
      const before = moving && this.activeStep != null ? this.tabs.map(tab => ({
        top: tab.getBoundingClientRect().top,
        ruleHeight: tab.querySelector(`${prefix}step-rule`).getBoundingClientRect().height
      })) : null;
      const outgoingTab = this.tabs[this.activeStep];
      const outgoing = before && outgoingTab?.querySelector('[data-step-description]');
      if (outgoing) {
        const copy = outgoing.cloneNode(true);
        const style = getComputedStyle(outgoing);
        copy.removeAttribute('data-step-description');
        copy.setAttribute('aria-hidden', 'true');
        copy.inert = true;
        Object.assign(copy.style, { position: 'absolute', top: `${outgoing.offsetTop}px`, left: `${outgoing.offsetLeft}px`, width: `${outgoing.getBoundingClientRect().width}px`, pointerEvents: 'none' });
        outgoingTab.append(copy);
        const animation = copy.animate([{ opacity: style.opacity, transform: style.transform }, { opacity: 0, transform: 'translateY(-4px)' }], { duration: 140, easing: 'cubic-bezier(.23,1,.32,1)', fill: 'forwards' });
        this.exitDescriptions.set(outgoingTab, { copy, animation });
        animation.onfinish = () => { copy.remove(); this.exitDescriptions.delete(outgoingTab); };
      }
      const incomingCopy = this.exitDescriptions.get(this.tabs[step]);
      const incomingOpacity = incomingCopy ? getComputedStyle(incomingCopy.copy).opacity : 0;
      if (incomingCopy) {
        incomingCopy.animation.cancel();
        incomingCopy.copy.remove();
        this.exitDescriptions.delete(this.tabs[step]);
      }
      this.navigationAnimations.forEach(animation => animation.cancel());
      this.navigationAnimations = [];
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === step));
        tab.tabIndex = i === step ? 0 : -1;
        const description = tab.querySelector('[data-step-description]');
        if (description) description.hidden = i !== step;
      });
      this.activeStep = step;
      if (!before) return;
      const timing = { duration: 260, easing: 'cubic-bezier(.23,1,.32,1)' };
      const after = this.tabs.map(tab => tab.getBoundingClientRect());
      this.tabs.forEach((tab, i) => {
        const delta = before[i].top - after[i].top;
        if (Math.abs(delta) > .5) this.navigationAnimations.push(tab.animate([{ transform: `translateY(${delta}px)` }, { transform: 'translateY(0)' }], timing));
        const scale = before[i].ruleHeight / after[i].height;
        if (Math.abs(scale - 1) > .01) this.navigationAnimations.push(tab.querySelector(`${prefix}step-rule`).animate([{ transform: `scaleY(${scale})` }, { transform: 'scaleY(1)' }], timing));
      });
      const description = this.tabs[step].querySelector('[data-step-description]');
      if (description) this.navigationAnimations.push(description.animate([{ opacity: incomingOpacity, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'translateY(0)' }], { ...timing, duration: 220 }));
    }

    clearNavigationMotion() {
      this.navigationAnimations?.forEach(animation => animation.cancel());
      this.navigationAnimations = [];
      for (const { copy, animation } of this.exitDescriptions?.values() || []) {
        animation.cancel();
        copy.remove();
      }
      this.exitDescriptions?.clear();
    }

    updatePlayback() {
      const running = this.autoplayEnabled && !this.motion.matches && this.inView && !document.hidden;
      this.toggleAttribute('data-running', running);
      if (!running) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.previousFrame = null;
        this.celebration?.clear();
        return;
      }
      if (!this.frame) this.frame = requestAnimationFrame(now => this.tick(now));
    }

    tick(now) {
      this.frame = 0;
      if (!this.hasAttribute('data-running')) return;
      if (this.previousFrame != null) this.elapsed += Math.min(100, Math.max(0, now - this.previousFrame));
      this.previousFrame = now;
      if (this.elapsed >= durations[this.index]) {
        const remainder = this.elapsed - durations[this.index];
        this.select((this.index + 1) % 6);
        this.elapsed = remainder;
        this.previousFrame = now;
      }
      this.renderFrame();
      this.updatePlayback();
    }

    destroyPlayers() {
      this.opening?.destroy();
      this.understand?.destroy();
      this.celebration?.destroy();
      this.results?.reset();
    }

    disconnect() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.previousFrame = null;
      this.events?.abort();
      this.observer?.disconnect();
      this.clearNavigationMotion();
      this.destroyPlayers();
    }

    disconnectedCallback() { this.disconnect(); }
  });
}
